import { AiOutlineEdit } from "react-icons/ai";
import ServiceRow from "./ServiceRow";

type Props = { data: any };

const TeamMemberServiceList = ({ data }: Props) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4 ">
        <h4 className="font-semibold text-xl text-color-primary">Services</h4>
        <AiOutlineEdit className="text-[#9999A7] flex items-center text-lg justify-center text-center " />
      </div>
      <div>
        <div className="text-color-primary text-sm mb-4">Services</div>
        <div className="flex flex-col items-center gap-4 w-full">
          {data?.services?.map((e: any) => {
            return <ServiceRow data={e} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default TeamMemberServiceList;
